import appLogger from "../../utils/app-logger";
// import Types from "./types";
import UserServiceApi from "../../services/user-service-api";

const resetPasswordAtempt = (data) => {
	
		return UserServiceApi
		.resetPasswordAtempt(data)
			.then((response) => {
				return response;
			})
			.catch((error) => console.log("Error"));
};

export { resetPasswordAtempt };
